import { TargetedOfferProductTag } from '@woolworthsnz/trader-api';

export const getOfferText = (offer?: TargetedOfferProductTag): string => {
	switch (offer?.targetedOfferType) {
		case TargetedOfferProductTag.TargetedOfferTypeEnum.AmountOff: {
			const offerValue = offer?.offerValue || 0;
			if (offerValue < 1 && offerValue !== 0) {
				return `${offerValue * 100}c Off`;
			}
			return `$${offer.offerValue} Off`;
		}
		case TargetedOfferProductTag.TargetedOfferTypeEnum.BonusProduct:
			return `Buy ${offer.criteriaValue} Get ${offer.offerValue} Free`;
		case TargetedOfferProductTag.TargetedOfferTypeEnum.FixedAmount:
			return `Only $${offer.offerValue}`;
		case TargetedOfferProductTag.TargetedOfferTypeEnum.FuelCentsOff:
			return `Save ${offer.offerValue}c per litre off fuel`;
		case TargetedOfferProductTag.TargetedOfferTypeEnum.Multibuy:
			return `${offer.criteriaValue} For $${offer.offerValue}`;
		case TargetedOfferProductTag.TargetedOfferTypeEnum.OnecardPoints:
			return `${offer.offerValue} Bonus Points`;
		case TargetedOfferProductTag.TargetedOfferTypeEnum.PercentageOff:
			return `${offer.offerValue}% Off`;
		case TargetedOfferProductTag.TargetedOfferTypeEnum.CategoryFuel:
		case TargetedOfferProductTag.TargetedOfferTypeEnum.CategoryFood:
			return 'Category Offer';
		case TargetedOfferProductTag.TargetedOfferTypeEnum.Unknown:
		default:
			return '';
	}
};
